import { createSlice } from '@reduxjs/toolkit'

const i18nSlice = createSlice({
    name: 'i18n',
    initialState: { locale: 'cs' },
    reducers: {
        setLocale(state, action) {
            const { payload } = action

            state.locale = payload
        },
    },
})

const { actions, reducer } = i18nSlice

export const { setLocale } = actions

export default reducer
